import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { HTMLAsset, useAsset } from '@techstyle/react-assets';
import { TextLink } from '@techstyle/react-components';
import { Checkbox } from '@techstyle/react-components-legacy';
import { FormattedMessage } from '@techstyle/react-intl';

import { mobile } from '../../styles';
import { BasicButton } from '../../styles/button';
import { Paragraph } from '../../styles/paragraph';
import { Component as EmailField } from '../EmailField';
import { Container as EmailSubscribeForm } from '../EmailSubscribeForm';
import { Container as RegistrationModal } from '../RegistrationModal';

const Container = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
`;

const SubscribeForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: ${props => props.theme.spacing.tiny}px;
`;

const StyledPrivacyLink = styled(TextLink)`
  text-decoration: underline;
  margin: auto;
  padding-top: ${props => props.theme.spacing.medium}px;
  color: ${props => props.theme.colors.default};
`;

const StyledCheckbox = styled(Checkbox)`
  color: ${props => props.theme.colors.default};
  margin-bottom: ${props => props.theme.spacing.small}px;
  text-align: left;
`;

const CheckboxParagraph = styled(Paragraph)`
  font-size: 12px;
  text-align: left;

  ${mobile`
    line-height: normal;
  `}
`;

function VipBoxRegistrationModal({
  onRequestSubscribe,
  subscribing = false,
  ...rest
}) {
  const assetContainerRegistrationModal = useAsset(
    'pdp_html_vip_box_registration_text'
  );
  const { data } = assetContainerRegistrationModal;
  const assetRegistrationModal = data ? data.assets[0] : null;
  return (
    <RegistrationModal
      {...rest}
      assetContainer="pdp_image_vip_box_registration"
    >
      <Container>
        {assetRegistrationModal && <HTMLAsset asset={assetRegistrationModal} />}
        <EmailSubscribeForm
          onSubmit={onRequestSubscribe}
          render={({
            email,
            emailError,
            isMarketingEmail,
            hideCheckbox,
            hideEmail,
            onChangeEmail,
            handleSubscribe,
            onChangeMarketingEmail,
          }) => {
            const error = emailError ? (
              <FormattedMessage
                id="global_cta.enter_valid_email"
                defaultMessage="Enter a valid email address"
              />
            ) : null;
            return (
              <SubscribeForm onSubmit={handleSubscribe}>
                {!hideEmail && (
                  <EmailField
                    dataAutotag="pii-vip-box-reg-email"
                    value={email}
                    onChange={onChangeEmail}
                    error={error}
                  />
                )}
                {!hideCheckbox && (
                  <StyledCheckbox
                    name="terms"
                    size="large"
                    verticalAlign="flex-start"
                    label={
                      <CheckboxParagraph>
                        <FormattedMessage
                          id="global_login.subscribe_to_emails"
                          defaultMessage="Yes, I want to receive emails from Savage X (optional)"
                        />
                      </CheckboxParagraph>
                    }
                    checked={isMarketingEmail}
                    onChange={onChangeMarketingEmail}
                  />
                )}
                <BasicButton
                  type="submit"
                  disabled={subscribing || !isMarketingEmail}
                >
                  <FormattedMessage
                    id="vip_box_registration.submit_button"
                    defaultMessage="Get on the list"
                  />
                </BasicButton>
              </SubscribeForm>
            );
          }}
        />
        <StyledPrivacyLink href="/privacypolicy">
          <FormattedMessage
            id="vip_box_registration.privacy_link"
            defaultMessage="Privacy Policy"
          />
        </StyledPrivacyLink>
      </Container>
    </RegistrationModal>
  );
}

VipBoxRegistrationModal.propTypes = {
  email: PropTypes.string,
  emailError: PropTypes.bool,
  handleSubscribe: PropTypes.func,
  hideCheckbox: PropTypes.bool,
  hideEmail: PropTypes.bool,
  isMarketingEmail: PropTypes.bool,
  onChangeEmail: PropTypes.func,
  onChangeMarketingEmail: PropTypes.func,
  onRequestSubscribe: PropTypes.func,
  subscribing: PropTypes.bool,
};

export default VipBoxRegistrationModal;
